export var OneDriveManageStorageUrl = 'https://go.microsoft.com/fwlink/?linkid=2228772';
export var LoginHintParam = 'login_hint';
//# sourceMappingURL=constant.js.map